<template>
	<svg
		class="loader"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 64 64"
		width="512"
		height="512"
	>
		<g id="flat">
			<g class="border">
				<rect rx="3" x="5" y="8" width="54" height="48"></rect>
			</g>
			<g class="bg">
				<rect x="7" y="10" width="50" height="44"></rect>
			</g>
			<g class="separator">
				<rect x="7" y="27" width="50" height="2"></rect>
			</g>
			<g class="section-separator">
				<rect x="31" y="10" width="2" height="44"></rect>
				<rect x="15" y="10" width="2" height="44"></rect>
				<rect x="46" y="10" width="2" height="44"></rect>
			</g>

			<g class="small-1">
				<rect x="11" y="38" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="11" y="46" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="11" y="42" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="11" y="50" width="10" height="4" rx="2" ry="2"></rect>
			</g>
			<g class="small-2">
				<rect x="27" y="46" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="27" y="42" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="27" y="38" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="27" y="34" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="27" y="50" width="10" height="4" rx="2" ry="2"></rect>
			</g>
			<g class="small-3">
				<rect x="42" y="46" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="42" y="42" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="42" y="50" width="10" height="4" rx="2" ry="2"></rect>
			</g>
			<g class="big-1">
				<rect x="11" y="23" width="10" height="4" rx="2" ry="2"></rect>
			</g>
			<g class="big-2">
				<rect x="27" y="23" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="27" y="19" width="10" height="4" rx="2" ry="2"></rect>
			</g>
			<g class="big-3">
				<rect x="42" y="15" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="42" y="19" width="10" height="4" rx="2" ry="2"></rect>
				<rect x="42" y="23" width="10" height="4" rx="2" ry="2"></rect>
			</g>
		</g></svg
></template>

<script>
export default {
	name: 'Loader',
}
</script>

<style lang="scss" scoped>
$black: #273136;

@keyframes rotate-preloader {
	0% {
		transform: rotate(0deg);
	}
	5% {
		transform: rotate(-5deg);
	}
	22% {
		transform: rotate(185deg);
	}
	25%,
	50% {
		transform: rotate(180deg);
	}

	55% {
		transform: rotate(185deg);
	}

	72% {
		transform: rotate(-5deg);
	}

	75%,
	100% {
		transform: rotate(0deg);
	}
}

@mixin donsAnimation($name, $padding) {
	@keyframes #{$name} {
		0%,
		25%,
		95%,
		100% {
			transform: translateY(0);
		}
		45%,
		50%,
		75% {
			transform: translateY($padding);
		}
		47.5% {
			transform: translateY($padding + 1px);
		}
		97.5% {
			transform: translateY(-1px);
		}
	}
}

@include donsAnimation('space-1', -5px);
@include donsAnimation('space-2', -9px);
@include donsAnimation('space-3', -13px);

$animation: 3.5s infinite linear;

.loader {
	width: 200px;
	animation: rotate-preloader $animation;

	.small-2,
	.big-3 {
		animation: space-1 $animation;
	}

	.small-1,
	.big-2 {
		animation: space-2 $animation;
	}

	.small-3,
	.big-1 {
		animation: space-3 $animation;
	}

	.border,
	.separator,
	.section-separator {
		rect {
			fill: $black;
		}
	}

	.bg rect {
		fill: #fff;
	}

	.small-1,
	.small-2,
	.small-3,
	.big-1,
	.big-2,
	.big-3 {
		rect {
			stroke-width: 0.25px;
			stroke: rgba($black, 0.5);
		}
	}

	.small-1,
	.big-1 {
		rect {
			fill: #faa43a;
		}
	}
	.small-2,
	.big-2 {
		rect {
			fill: #ef5181;
		}
	}

	.small-3,
	.big-3 {
		rect {
			fill: #6d4a98;
		}
	}
}
</style>
